export { default as ThreeDStockMaterialsFiltersFavoritesFilter } from './ThreeDStockMaterialsFiltersFavoritesFilter';
